import React from "react";
import useModal from "../@shared/components/Modal/hooks/useModal";
import { ShareModalContent } from "../containers/ListingDetailPage/(components)/ShareModalContent";
import { useUsers } from "../hooks/collections/useUsers";
import { useParams } from "react-router-dom";
import { useUserSessionStore } from "../stores/UserSession.store";
import { useAlert } from "../@shared/hooks/useAlert";

const LikeSaveButtons = () => {
  const alert = useAlert();
  const params = useParams();
  const user = useUserSessionStore((state) => state.user);
  const modal = useModal();
  const { toggleFavoriteService } = useUsers({ loadData: false });
  const handleOpenShareModal = () => {
    modal.open({
      title: "Share this service",
      content: <ShareModalContent/>,
      onHide: () => {
        modal.close();
      }
    });
  };

  const isFavorite = user?.favorites?.some((favorite) => favorite.id === params.id);
  const handleFavoriteToggle = () => {
    toggleFavoriteService(user.id, params.id);
    !isFavorite ? alert.toastSuccess("Saved in favorites") : alert.toastError("Removed from favorites");
  }

  return (
    <div className="flow-root">
      <div className="flex text-neutral-700 dark:text-neutral-300 text-sm -mx-3 -my-1.5">
        <span
          className="py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
          onClick={handleOpenShareModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
            />
          </svg>
          <span className="hidden sm:block ml-2.5">Share</span>
        </span>
        {user && (
          <span
            onClick={handleFavoriteToggle} className="py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
          >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill={isFavorite ? "currentColor" : "none"}
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
          <span className="hidden sm:block ml-2.5">Save</span>
        </span>
        )}
      </div>
    </div>
  );
};

export default LikeSaveButtons;
